
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import './assets/css/global.css'
import  'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts'
import qs from 'qs'
import store from './store/index.js'
import VueDragResize from "vue-drag-resize"
import cookies from 'vue-cookies'
import x2js from 'x2js' //xml数据处理插件




Vue.prototype.$x2js = new x2js() //全局方法挂载

//cookies
Vue.prototype.$cookies = cookies;


Vue.component('vue-drag-resize', VueDragResize)
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

//挂在axios
Vue.prototype.qs = qs;

Vue.prototype.$http=axios

axios.defaults.withCredentials = true

//本地配置

//axios.defaults.baseURL='http://localhost:8802/api/'

//云端

axios.defaults.baseURL='https://unione-robot.com/api/'

//测试
//axios.defaults.baseURL='https://unione-tech.com:442/api/'


axios.interceptors.request.use(config =>{
  return config;
})



var that=this
setInterval(()=>{
  store.dispatch('mqttServer')
  location.reload()
},600000)


//系统错误捕获
Vue.config.errorHandler = function(err, vm, info) {
  console.log(`Error: ${err.toString()}\nInfo: ${info}`);
};



router.beforeEach((to, from, next) => {
  console.log(to)
  if(from.path=="/home"){
    console.log("111111111111111")
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js